angular.module('lsnBase.addresses', [
  'lsnBase.availability'
]);